module.exports = __webpack_public_path__ + "static/media/qr_code.6b71e375.png";